import { Component, Input, OnInit, EventEmitter } from '@angular/core'

import { WidgetComponent } from '../../view'
import { RowField } from '../../config'

/**
 * can use for: text
 */
@Component({
  selector: 'bp--preset--form-text-widget',
  template: `
    <input
      nz-input
      readonly
      onfocus="this.removeAttribute('readonly');"
      [type]="field.extra"
      [placeholder]="field.form.placeholder || ''"
      [disabled]="readonly"
      [ngModel]="value"
      (ngModelChange)="change.emit($event)"
    />
  `,
})
export class BpFormTextWidget extends WidgetComponent implements OnInit {
  static meta = {
    type: 'preset_form',
    name: 'text',
  }

  @Input() entity: any
  @Input() value: string
  @Input() field: RowField

  change = new EventEmitter<string>()
  readonly = false

  ngOnInit() {
    this.readonly = this.field.feature.includes('readonly')
  }
}
